import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "../services/apiService";

/* Get Branch Service */
const getAllBranches = (params) => {
    const { axiosInstance ,config,source} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.branches.getAllBranches}`,
      method: "POST",
      data: params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

export default {
    getAllBranches,
}